import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  InfinityMarquee: {
    id: 'label_infinity_marquee',
    defaultMessage: 'Infinity marquee',
  },
  Terms: {
    id: 'label_terms',
    defaultMessage: 'Terms',
  },
});
